import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Helpers } from 'app/core/helpers/helpers';
import { extractHttpErrorMessage } from 'app/core/helpers/http-error';
import { AvatarPipe } from 'app/core/pipes/avatar.pipe';
import { ToastService } from 'app/core/services/toast.service';
import { AuthService } from 'app/modules/auth/auth.service';
import { UserService } from 'app/modules/users/users.service';
import moment from 'moment';

const PROFILE_FIELDS: { key: string; label: string }[] = [
  { key: 'mobile', label: 'Mobile Number' },
  { key: 'designation', label: 'Designation' },
  { key: 'profile_image_url', label: 'Profile Picture' },
  { key: 'dob', label: 'Date of Birth' },
  { key: 'passport_number', label: 'Passport Number' },
  { key: 'passport_expiry', label: 'Passport Expiry' },
  { key: 'emirates_id', label: 'National ID' },
  { key: 'emirates_id_expiry', label: 'National ID Expiry' },
  { key: 'id_file_url', label: 'ID File' },
];

@Component({
  selector: 'app-profile-completion-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDividerModule, MatIconModule, AvatarPipe],
  templateUrl: './profile-completion-dialog.component.html',
})
export class ProfileCompletionDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ProfileCompletionDialogComponent>);

  private authService = inject(AuthService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private userService = inject(UserService);
  private toast = inject(ToastService);

  completionPercent = 0;
  displayPercent = 0;
  missingFields: string[] = [];
  user: any = null;
  loading = 0;

  ngOnInit(): void {
    const profile = this.authService.profile();
    this.user = profile;
    this.missingFields = PROFILE_FIELDS.filter((field) => Helpers.empty(profile?.[field.key])).map((field) => field.label);
    this.completionPercent = Math.round(((PROFILE_FIELDS.length - this.missingFields.length) / PROFILE_FIELDS.length) * 100);
    setTimeout(() => {
      this.displayPercent = this.completionPercent;
      this.cdr.markForCheck();
    }, 300);
  }

  close(): void {
    this.dialogRef.close();
  }

  remindLater(): void {
    const profile = this.authService.profile();
    if (!profile) return;

    this.loading++;
    const remindAfter = moment().add(30, 'days').format('YYYY-MM-DD');
    this.userService.updateProfile({ profile_reminder_date: remindAfter }).subscribe({
      next: () => {
        this.loading--;
        this.authService.profile.set({ ...profile, profile_reminder_date: remindAfter });
        this.toast.success("We'll remind you again in 30 days");
        this.dialogRef.close();
      },
      error: (err) => {
        this.loading--;
        this.cdr.markForCheck();
        this.toast.error(extractHttpErrorMessage(err, 'Unable to set reminder. Please try again.'));
      },
    });
  }

  goToEditProfile(): void {
    this.dialogRef.close();
    this.router.navigate(['/profile/edit']);
  }
}
